import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

// Your configuration
const firebaseConfig = {
  apiKey: "AIzaSyCtIcBR-1YSprB5W1zh2L-RxBUvr-KkFGY",
  authDomain: "the-machete-man.firebaseapp.com",
  projectId: "the-machete-man",
  storageBucket: "the-machete-man.firebasestorage.app",
  messagingSenderId: "767325644762",
  appId: "1:767325644762:web:9c32602fcecee22ea2c2e3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export tools
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const auth = getAuth(app);